import { useRef } from 'react';

import { useRequestProcessing } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { useUpload } from './useUpload';
import {
  bulkUpload,
  bulkUploadStatus,
  uploadFileChunk,
} from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { upload as uploadKey } from '../queryKeyFactory';
import { messagesBulkCreatives } from '../messages';

const STATUS_COMPLETED = 'Completed';
const STATUS_FAILED = 'Failed';
// const STATUS_NOT_STARTED = 'NotStarted';
// const STATUS_RUNNING = 'Running';

export const useBulkUpload = () => {
  const uploadMessage = messagesBulkCreatives.upload();

  const { showMessage } = useScreenMessage();

  let processSnackbarRef = useRef();

  const [uploadFile] = useUpload({
    onProgress: (percent) => {
      processSnackbarRef.current?.update(uploadMessage.processing(percent));
    },
    source: uploadFileChunk,
  });

  const [mutateAsync, mutation] = useRequestProcessing(
    uploadKey(),
    bulkUpload,
    bulkUploadStatus,
    {
      refresh: false,
      isCompleted: (result) => result?.status === STATUS_COMPLETED,
      isFailed: (result) => result?.status === STATUS_FAILED,
      getCompletedMessage: () => uploadMessage.completed(),
      getFailedMessage: () => uploadMessage.failed(),
      getProcessMessage: (result) =>
        uploadMessage.processing(result?.percentsCompleted),
    }
  );

  return [
    async ({ file, conceptId }) => {
      const fileGuid = await uploadFile({ file });

      processSnackbarRef.current = showMessage(uploadMessage.processing(), {
        ttl: 1000 * 60 * 30,
      });

      return mutateAsync({
        fileGuid,
        conceptId,
      });
    },
    mutation,
  ];
};
